import { load, ReCaptchaInstance } from 'recaptcha-v3';

export enum RecaptchaActions {
  SubmitContactForm = 'SubmitContactForm',
}

export const loadRecaptcha = (siteKey: string) => {
  return new Promise<ReCaptchaInstance>(async (resolve, reject) => {
    try {
      const recaptchaInstance = await load(siteKey);
      resolve(recaptchaInstance);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const getActionToken = (
  recaptchaInstance: ReCaptchaInstance,
  action: RecaptchaActions
): Promise<string> => {
  return new Promise<string>(async (resolve, reject) => {
    try {
      const actionToken = await recaptchaInstance.execute(action);
      resolve(actionToken);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
